module.exports = __webpack_public_path__ + "img/control-processor-2.c92447ae.svg";